import { useEffect, useState } from "react";
const useIdleTimeout = (timeoutSeconds: number, callback: () => void) => {
  const [timer, setTimer] = useState(timeoutSeconds);
  useEffect(() => {
    const myInterval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        clearInterval(myInterval);
        callback();
      }
    }, 1000);
    const resetTimeout = () => {
      setTimer(timeoutSeconds);
    };
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];
    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }
    return () => {
      clearInterval(myInterval);
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
      }
    };
  });
  return timer;
};
export default useIdleTimeout;
